"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Bubblies = require("./Bubblies/Bubblies");

var _Bubblies2 = _interopRequireDefault(_Bubblies);

var _propTypes2 = require("./propTypes");

var _propTypes3 = _interopRequireDefault(_propTypes2);

require("./Bubbly.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bubbly = function (_PureComponent) {
  _inherits(Bubbly, _PureComponent);

  function Bubbly() {
    _classCallCheck(this, Bubbly);

    return _possibleConstructorReturn(this, (Bubbly.__proto__ || Object.getPrototypeOf(Bubbly)).apply(this, arguments));
  }

  _createClass(Bubbly, [{
    key: "renderHeader",
    value: function renderHeader() {
      var _props = this.props,
          headerAriaLevel = _props.headerAriaLevel,
          header = _props.header;


      if (!header) return null;
      return _react2.default.createElement(
        "div",
        { className: "aclui-bubbly__header", role: "heading", "aria-level": headerAriaLevel },
        header
      );
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (!this.props.footer) return null;
      return _react2.default.createElement(
        "div",
        { className: "aclui-bubbly__footer" },
        this.props.footer
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          alignBubbly = _props2.alignBubbly,
          bubblyType = _props2.bubblyType,
          maxWidth = _props2.maxWidth,
          content = _props2.content,
          className = _props2.className;


      var rootClasses = (0, _classnames2.default)("aclui-bubbly", className, "aclui-bubbly--align-" + alignBubbly);

      return _react2.default.createElement(
        "div",
        { className: rootClasses },
        _react2.default.createElement(
          "div",
          { className: "aclui-bubbly__bubbly-column" },
          _react2.default.createElement(_Bubblies2.default, { type: bubblyType })
        ),
        _react2.default.createElement(
          "div",
          { className: "aclui-bubbly__message", style: { maxWidth: maxWidth } },
          this.renderHeader(),
          _react2.default.createElement(
            "div",
            { className: "aclui-bubbly__content" },
            content
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return Bubbly;
}(_react.PureComponent);

Bubbly.propTypes = {
  /** Defines the hierarchical level of an element within a structure. */
  headerAriaLevel: _propTypes.number.isRequired,

  /** select the mascot type */
  bubblyType: _propTypes3.default,

  /** Aligns the position of the bubbly image */
  alignBubbly: (0, _propTypes.oneOf)(["top", "center"]),

  /** Content text */
  content: _propTypes.node.isRequired,

  /** Optional class names */
  className: _propTypes.string,

  /** Text below content. If not specified, the footer should be empty */
  footer: _propTypes.node,

  /** Header text above content. If not specified, the header should empty */
  header: _propTypes.node,

  /** Dictates the maximum width of the bubbly component */
  maxWidth: _propTypes.string
};

Bubbly.defaultProps = {
  headerAriaLevel: 3,
  bubblyType: "default",
  alignBubbly: "top",
  maxWidth: "none"
};

Bubbly.Error = function () {
  return _react2.default.createElement(_Bubblies2.default, { type: "error" });
};
Bubbly.Mascot = function () {
  return _react2.default.createElement(_Bubblies2.default, null);
};
Bubbly.Search = function () {
  return _react2.default.createElement(_Bubblies2.default, { type: "searchDefault" });
};
Bubbly.SearchActive = function () {
  return _react2.default.createElement(_Bubblies2.default, { type: "searchActive" });
};
Bubbly.SearchNoResults = function () {
  return _react2.default.createElement(_Bubblies2.default, { type: "searchNoResults" });
};
Bubbly.NoneAvailable = function () {
  return _react2.default.createElement(_Bubblies2.default, { type: "noneAvailable" });
};

exports.default = Bubbly;